<template>
  <f7-card outline header-divider>
    <f7-card-header class=""
      ><span> {{ $t("common.transactions") }} </span
      ><span class="float-right downloadTransactIcon tabbar">
        <f7-link
          @click="openAdaptiveModal('.downloadTransactions')"
          icon-ios="f7:arrow_down_circle"
          icon-md="material:download"
          class="float-right"
          text-color="gray"
          :text="$t('post.download')"
        ></f7-link
      ></span>
    </f7-card-header>
    <div class="cols90_10 margin-bottom">
      <f7-searchbar
        class="searchbar-transactions"
        search-container=".transactions-list"
        :placeholder="$t('common.search')"
        search-group-title=".list-group-title"
        hide-groups:false
        search-in=".item-title, .item-after, .item-subtitle, item-header, .item-footer"
      >
      </f7-searchbar>
      <f7-link
        popover-open=".sortingPopup"
        icon-ios="f7:sort_up"
        icon-md="material:filter_list"
      ></f7-link>
    </div>
    <!---->
    <f7-card-content>
      <f7-list
        dividers
        strong-ios
        transaction-list
        class="searchbar-not-found"
        media-list
        v-if="!!transactionList && transactionList.length < 1"
      >
        <f7-list-item
          :title="$t('common.nothingFound')"
          style="font-size: 18px; color: red"
        >
        </f7-list-item>
      </f7-list>

      <f7-list
        dividers
        media-list
        accordion-list
        strong-ios
        class="transactions-list searchbar-found margin-bottom"
        v-if="transactionList && transactionList.length > 0"
        v-for="(transactions, index) in currentTransactionList(
          transactionList,
          groupBy,
        )"
        :key="index"
      >
        <f7-list-group>
          <f7-list-item group-title class="margin-horizntal">
            <f7-chip
              :outline="theme.md ? false : true"
              color="primary"
              :text="
                groupBy === 'status'
                  ? transactionStatus(transactions.groupBy) &&
                    transactionStatus(transactions.groupBy).status
                  : transactions.groupBy
              "
            >
            </f7-chip>
            <span style="font-size: 75%; font-style: italic; margin-left: 8px">
              <f7-icon
                ios="f7:arrow_up_circle"
                md="material:arrow_circle_up"
                color="primary"
                size="22px"
              ></f7-icon
              ><span
                v-html="
                  '+' +
                  $filtersToCurrency.toCurrency(
                    transactions.subTotalReceived,
                    '',
                    transactions.currency,
                  )
                "
              ></span>
              <f7-icon
                ios="f7:arrow_down_circle"
                md="material:arrow_circle_down"
                color="red"
                size="22px"
              ></f7-icon
              ><span
                v-html="
                  '-' +
                  $filtersToCurrency.toCurrency(
                    transactions.subTotalPaid,
                    '',
                    transactions.currency,
                  )
                "
              ></span>
              <f7-icon
                ios="f7:arrow_right_circle"
                md="f7:arrow_right_circle"
                color="gray"
                size="22px"
              ></f7-icon>
              <span
                :style="{
                  color: transactions.subTotal < 0 ? 'red' : 'primary',
                }"
                v-html="
                  $filtersToCurrency.toCurrency(
                    transactions.subTotal,
                    '',
                    transactions.currency,
                  )
                "
              ></span>
            </span>
            <!-- :style="{
            'border-style': solid,
            ' border-width': '1px',
            'border-color': transactionStatus(transaction.status)
              ? transactionStatus(transaction.status).color
              : 'auto',
          }"  -->
          </f7-list-item>
          <f7-list-item
            v-for="(transaction, index) in transactions.items"
            :key="index"
            accordion-item
            :title="transaction.senderName"
            :footer="$dayjs(transaction.creation_date).format('lll')"
            :text="transaction.tag"
            :badge="
              transactionStatus(transaction.status)
                ? transactionStatus(transaction.status) &&
                  transactionStatus(transaction.status).status
                : transaction.status
            "
            :badge-color="
              transactionStatus(transaction.status)
                ? transactionStatus(transaction.status) &&
                  transactionStatus(transaction.status).color
                : 'primary'
            "
            :class="
              'highlighted_horiz border-color-' +
              (transactionStatus(transaction.status)?.color || 'primary')
            "
          >
            <template #subtitle style="font-weight: bold"
              ><span
                v-if="transaction.status === 'CONFIRMED'"
                :style="{
                  color:
                    transaction.walletActivity &&
                    transaction.walletActivity.type === 'CREDIT'
                      ? 'primary'
                      : 'red',
                }"
              >
                <span
                  v-html="
                    transaction.walletActivity &&
                    transaction.walletActivity.type === 'CREDIT'
                      ? '+'
                      : '-'
                  "
                ></span>
                {{
                  $filtersToCurrency.toCurrency(
                    (transaction.amount || 0).toFixed(2),
                    null,
                    transaction.currency,
                  )
                }}</span
              ><span v-else>
                {{
                  $filtersToCurrency.toCurrency(
                    (transaction.amount || 0).toFixed(2),
                    null,
                    transaction.currency,
                  )
                }}</span
              >
            </template>
            <template #media>
              <img
                v-if="
                  transaction.senderUserId !== null &&
                  getCurrentUser(transaction.senderUserId) &&
                  getCurrentUser(transaction.senderUserId).avatar !== ''
                "
                :src="`${getCurrentUser(transaction.senderUserId).avatar}`"
                width="24"
              />
              <f7-badge
                v-else-if="transaction.senderName"
                color="auto"
                style="
                  height: 48px;
                  width: 48px;
                  font-size: 16px;
                  border-radius: 50%;
                "
              >
                {{ $filtersGetInitial.getInitial(transaction.senderName) }}
              </f7-badge>
            </template>
            <f7-accordion-content>
              <f7-list dividers-ios strong-ios media-list>
                <f7-list-group v-if="transaction.status === 'AUTHORIZED'">
                  <span
                    v-if="
                      transaction.trxValidatorList.length > 0 &&
                      transaction.trxValidatorList.find(
                        (user) => user.userId === profile.sub,
                      )
                    "
                  >
                    <div class="grid cols70_30">
                      <f7-input
                        type="text"
                        :label="$t('common.transferCode')"
                        disabled
                        readonly
                        class="padding-left-half"
                        :value="transaction.transferCode"
                      />

                      <f7-input
                        :label="$t('common.pin')"
                        type="text"
                        :placeholder="$t('common.pin')"
                        inputmode="numeric"
                        input-id="transferPIN"
                        :value="transaction.transferPIN"
                        @input="transferPIN = $event.target.value"
                        @keyup.enter="validateTransaction(transaction)"
                        pattern="[0-9]*"
                        maxlength="4"
                        size="4"
                        required
                      ></f7-input>
                    </div>
                    <f7-button
                      raised
                      fill
                      ripple
                      class="margin"
                      color="red"
                      strong
                      @click="validateTransaction(transaction)"
                      >{{ $t("common.validateTransfer") }}</f7-button
                    >
                  </span>
                  <f7-list-item v-else
                    >{{ $t("common.transferCode") }}:
                    {{ transaction.transferCode }}</f7-list-item
                  >
                </f7-list-group>
                <f7-list-group
                  v-if="
                    transaction.trxValidatorList &&
                    transaction.trxValidatorList.length > 0
                  "
                >
                  <f7-list-item
                    v-for="(approver, index) in transaction.trxValidatorList"
                    :key="index"
                    :title="approver.name"
                    :footer="
                      approver.isValidated
                        ? $dayjs(approver.validation_date).format('lll	')
                        : ''
                    "
                  >
                    <template #after>
                      <f7-chip
                        outline
                        :text="
                          approver.isValidated
                            ? $t('common.confirmed')
                            : $t('common.pending')
                        "
                        :color="approver.isValidated ? 'green' : 'deeporange'"
                      ></f7-chip
                    ></template>
                    <template #media>
                      <img
                        v-if="
                          approver.userId !== null &&
                          getCurrentUser(approver.userId) &&
                          getCurrentUser(approver.userId).avatar !== ''
                        "
                        :src="`${getCurrentUser(approver.userId).avatar}`"
                        width="24"
                      />
                      <f7-badge
                        v-else-if="approver.name"
                        color="auto"
                        style="
                          height: 24px;
                          width: 24px;
                          font-size: 12px;
                          border-radius: 50%;
                        "
                      >
                        {{ $filtersGetInitial.getInitial(approver.name) }}
                      </f7-badge>
                    </template>
                  </f7-list-item>
                </f7-list-group>
              </f7-list>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list-group>
      </f7-list>
    </f7-card-content>
  </f7-card>
  <f7-popover
    class="sortingPopup"
    :backdrop="false"
    :params="{
      backdrop: false,
      closeOnEscape: true,
    }"
  >
    <f7-list dividers-ios strong-ios media-list>
      <f7-list-group>
        <f7-block-title medium>{{
          $t("walletdetail.groupCampaignsBy")
        }}</f7-block-title>

        <f7-list-item
          popover-close
          v-for="criteria in groupingCriteria"
          :key="criteria.index"
          radio
          href="#"
          :value="criteria.value"
          :title="criteria.name"
          @change="
            (e) => {
              if (e.target.checked) groupBy = criteria.value;
            }
          "
          @click="setTransactionList(criteria.value, false)"
          name="groupBy"
        ></f7-list-item>
      </f7-list-group>
      <f7-list-group>
        <f7-block-title medium>{{
          $t("walletdetail.sortCampaignsBy")
        }}</f7-block-title>
        <f7-list-item
          popover-close
          v-for="criteria in sortingCriteria"
          :key="criteria.index"
          link="#"
          class="sortBy-list"
          :title="criteria.name"
          @click="selectSortingCriteria(criteria.value)"
          ><template #after
            ><f7-icon
              class="sortingIcons"
              :id="'icon_' + criteria.value"
              :ios="isDesc ? 'f7:arrow_up_circle' : 'f7:arrow_down_circle'"
              :md="
                isDesc
                  ? 'material:arrow_circle_up'
                  : 'material:arrow_circle_down'
              "
            ></f7-icon></template
        ></f7-list-item>
      </f7-list-group>
    </f7-list>
  </f7-popover>
  <AdaptiveSheet
    class="downloadTransactions"
    style="--f7-sheet-bg-color: #fff"
    :tablet-fullscreen="true"
    full-screen
    backdrop
    :swipe-to-close="false"
    :close-by-backdrop-click="false"
    :close-on-escape="false"
  >
    <f7-view>
      <f7-page>
        <f7-navbar>
          <div class="left"></div>
          <div class="title">
            {{ $t("common.transactions") }}
          </div>
          <div class="right">
            <f7-link sheet-close popup-close icon-f7="multiply"></f7-link>
          </div>
        </f7-navbar>
        <div class="layout_content">
          <div class="left_layout"></div>
          <div class="main_layout">
            <f7-block-title
              > {{$t('transaction.downloadDateRangeText')}}</f7-block-title
            >
            <f7-list dividers-ios strong-ios media-list>
              <f7-list-group>
                <f7-list-input
                  :label="$t('transaction.downloadDateRange')"
                  type="datepicker"
                  floating-label
                  outline
                  :placeholder="$t('transaction.downloadDateRange')"
                  readonly
                  :value="extractionPeriod"
                  @calendar:change="(value) => (extractionPeriod = value)"
                  :calendar-params="{
                    rangePicker: true,
                    closeOnSelect: true,
                    openIn: 'auto',

                    header: true,
                    footer: true,
                  }"
                  :error-message="$t('transaction.downloadDateRange')"
                  :info="campaignDays"
                  clear-button
                ></f7-list-input>
                <f7-button
                  raised
                  fill
                  ripple
                  class="margin"
                  color="red"
                  strong
                  @click="downloadTransactions()"
                  >{{ $t("post.download") }}</f7-button
                >
              </f7-list-group>
            </f7-list>
             {{ selected_status }}
            <div class="card data-table">
              <table>
                <thead>
                  <tr>
                    <th class="input-cell">
                      <span class="table-head-label">{{
                        $t("common.sender")
                      }}</span>
                      <div class="input">
                       

                        <input
                          type="text"
                           :value="sender_name_filter"
                            @input="sender_name_filter = $event.target.value"
                          @keyup="filterByCriteria(sender_name_filter,'senderName','search')"
                          class="filterBySender"
                          :placeholder="$t('common.sender')"
                        />
                      </div>
                    </th>
                    <th
                      :class="'numeric-cell sortByAmount sortable-cell sortable-cell-active'+isDesc ? 'sortable-desc' : 'sortable-asc'" @click="filterByCriteria('','amount','sort')"
                    >
                      {{ $t("common.amount") }}
                     
                    </th>
                    <th
                      :class="'numeric-cell sortbydate sortable-cell sortable-cell-active'+isDesc ? 'sortable-desc' : 'sortable-asc'" @click="filterByCriteria('','creation_date','sort')"
                    >
                      {{ $t("common.date") }}
                     
                    </th>
                 
                    <th class="input-cell">
                      <span class="table-head-label">{{
                        $t("common.status")
                      }}</span>
                      <div class="input input-dropdown">
                        <select  v-model="selected_status" @change="filterByCriteria(selected_status,'status','select')" class="filterByStatus">
                          <option value="">{{ $t("common.all") }}</option>
                          <option v-if="transactionsStatusList(transactionList)"
                            v-for="trx_status in transactionsStatusList(transactionList)"
                            :value="trx_status.value"
                           
                          >
                            {{ trx_status.status }}
                          </option>
                        </select>
                      </div>
                    </th>
                   
                    <th class="input-cell">
                      <span class="table-head-label">{{
                        $t("common.tag")
                      }}</span>
                      <div class="input">
                        <input type="text" :value="tag_filter"  @input="tag_filter = $event.target.value"
                          @keyup="filterByCriteria(tag_filter,'tag','search')" class="filterByTag" :placeholder="$t('common.tag')" />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="transaction in filteredTransactionList"
                    :key="transaction.id"
                    class="transactionsBlock-list"
                  >
                    <td
                      class="label-cell senderLabel no-margin padding-horizontal-half"
                    >
                      {{ transaction.senderName }}
                    </td>

                    <td class="numeric-cell no-margin padding-horizontal-half">
                      <span
                        v-if="transaction.status === 'CONFIRMED'"
                        :style="{
                          color:
                            transaction.walletActivity &&
                            transaction.walletActivity.type === 'CREDIT'
                              ? 'primary'
                              : 'red',
                        }"
                      >
                        <span
                          v-html="
                            transaction.walletActivity &&
                            transaction.walletActivity.type === 'CREDIT'
                              ? '+'
                              : '-'
                          "
                        ></span>
                        {{
                          $filtersToCurrency.toCurrency(
                            (transaction.amount || 0).toFixed(2),
                            null,
                            transaction.currency,
                          )
                        }}</span
                      ><span v-else>
                        {{
                          $filtersToCurrency.toCurrency(
                            (transaction.amount || 0).toFixed(2),
                            null,
                            transaction.currency,
                          )
                        }}</span
                      >
                    </td>
                    <td class="numeric-cell no-margin padding-horizontal-half">
                      {{ $dayjs(transaction.creation_date).format("lll") }}
                    </td>
                    <td class="numeric-cell no-margin padding-horizontal-half">
                      <f7-chip class="padding-vertical-half margin-vertical-half"
                        style="font-size: x-small"
                        :text="
                          transactionStatus(transaction.status)
                            ? transactionStatus(transaction.status).status
                            : transaction.status
                        "
                        :color="
                          transactionStatus(transaction.status)
                            ? transactionStatus(transaction.status).color
                            : 'primary'
                        "
                      ></f7-chip
                    >
                    </td>
                      
                    <td
                      class="label-cell no-margin padding-horizontal-half tagLabel"
                    >
                      {{ transaction.tag }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="right_layout"></div>
        </div>
      </f7-page>
    </f7-view>
  </AdaptiveSheet>
</template>
<style scoped>
.sortingIcons {
  display: none;
}

.downloadTransactIcon {
  font-size: x-small;
  color: gray;
}

.sortBy-list:hover .sortingIcons {
  display: block;
}

td.numeric-cell,
td.label-cell {
  font-size: x-small;
}
</style>
<script setup>
import { ref, computed, onMounted } from "vue";
import { f7, theme } from "framework7-vue";
import { useCharts } from "../../js/composables/useCharts.js";
import AdaptiveSheet from "../common/AdaptiveSheet.vue";
import { openAdaptiveModal } from "../../js/composables/useAdaptiveModal.js";
import { useTransactionStatus } from "../../js/composables/useTransactionStatus.js";
import { useAuthStore } from "../../js/pinia-stores/auth.js";
import { useAccountStore } from "../../js/pinia-stores/account.js";
import { useApimoneyStore } from "../../js/pinia-stores/apimoney.js";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { FileOpener } from "@capawesome-team/capacitor-file-opener";
import write_blob from "capacitor-blob-writer";
import { Capacitor } from "@capacitor/core";
import i18n from "../../js/i18n.js";
const { t } = i18n.global;

const orderBy = ref("creation_date");
const orderingDir = ref("desc");
const isDesc = ref(true);
const groupBy = ref("transactionYearMonthDay");
const color = ref("");
const status = ref("");
const init = ref(true);
const extractionPeriod = ref([]);
const filteredTransactionList = ref([]);
const sender_name_filter = ref("");
const tag_filter = ref("");
const selected_status = ref("");

const groupingCriteria = ref([
  { value: "transactionYearQuarter", name: t("common.quarter") },
  { value: "transactionYearMonth", name: t("common.paymentDate") },
  { value: "transactionYearMonthWeek", name: t("common.paymentWeek") },
  { value: "transactionYearMonthDay", name: t("common.paymentDay") },
  { value: "senderName", name: t("common.sender") },
  { value: "status", name: t("common.status") },
  { value: "currency", name: t("common.currency") },
]);

const sortingCriteria = ref([
  { value: "senderName", name: t("common.sender") },
  { value: "creation_date", name: t("common.paymentDate") },
  { value: "amount", name: t("common.amount") },
  { value: "status", name: t("common.status") },
]);

const colors = ref([
  { color: "red", color_hex: "#ff3b30" },
  { color: "deeppurple", color_hex: "#673ab7" },
  { color: "deeporange", color_hex: "#ff6b22" },
  { color: "green", color_hex: "#4cd964" },
  { color: "pink", color_hex: "#ff2d55" },
  { color: "orange", color_hex: "#ff9500" },
  { color: "teal", color_hex: "#009688" },
  { color: "purple", color_hex: "#9c27b0" },
  { color: "lime", color_hex: "#cddc39" },
  { color: "blue", color_hex: "#2196f3" },
  { color: "lightblue", color_hex: "#5ac8fa" },
  { color: "yellow", color_hex: "#ffcc00" },
  { color: "#B5179E", color_hex: "#B5179E" },
  { color: "#086375", color_hex: "#086375" },
  { color: "#87677b", color_hex: "#87677b" },
]);

// Chart state refs (not rendered in template but required by useCharts)
const dataValue = ref([]);
const axisData = ref([]);
const area_name = ref("");
const barData = ref([]);
const barLabel = ref([]);
const bar_name = ref("");
const pieData = ref([]);
const pieLabel = ref([]);
const areaChartSeries = ref([]);
const barChartSeries = ref([]);
const pieChartSeries = ref([]);
const areaChartOptions = ref({});
const barChartOptions = ref({});
const pieChartOptions = ref({});

const users = computed(() => useAccountStore().users);

const {
  transactionList,
  isTablet,
  profile,
  transactionStatus,
  transactionsStatusList,
  selectSortingCriteria,
  getCurrentUser,
  currentTransactionList,
  setTransactionList: setTransactionListFn,
} = useCharts({
  orderBy,
  isDesc,
  orderingDir,
  groupBy,
  dataValue,
  axisData,
  area_name,
  barData,
  barLabel,
  bar_name,
  pieData,
  pieLabel,
  areaChartSeries,
  barChartSeries,
  pieChartSeries,
  areaChartOptions,
  barChartOptions,
  pieChartOptions,
  groupingCriteria,
  users,
});

onMounted(() => {
  setTransactionListFn("status", true);
  transactionsStatusList(transactionList.value);
  filteredTransactionList.value = transactionList.value;
});

function getWalletTransaction() {
  useApimoneyStore().getApiWalletTransactions({
    walletId: useApimoneyStore().apiWallet.id,
    start_date: startDate.value,
    end_date: endDate.value,
  });
}

function filterByCriteria(value, criteria, type) {
  if (type === "select") {
    filteredTransactionList.value = transactionList.value.filter((transaction) =>
      transaction[criteria]
        ? transaction[criteria].toLowerCase().includes(selected_status.value.toLowerCase())
        : false,
    );
  } else if (type === "sort") {
    isDesc.value = !isDesc.value;
    filteredTransactionList.value.sort((a, b) => {
      if (isDesc.value) {
        return a[criteria] < b[criteria] ? 1 : -1;
      } else {
        return a[criteria] > b[criteria] ? 1 : -1;
      }
    });
  } else if (type === "search") {
    const filterVal = criteria === "senderName" ? sender_name_filter.value : tag_filter.value;
    filteredTransactionList.value = transactionList.value.filter((transaction) =>
      transaction[criteria]
        ? transaction[criteria].toLowerCase().includes(filterVal.toLowerCase())
        : false,
    );
  }
}

async function downloadTransactions() {
  if (!transactionList.value?.length) {
    f7.toast.show({
      text: t("transaction.noTTransactions"),
      position: "center",
    });
    return;
  }

  const escapeCsvField = (field) => {
    if (field == null) return "";
    const str = String(field);
    if (str.includes(",") || str.includes('"') || str.includes("\n")) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const formatDate = (date) => {
    return date ? f7.$dayjs(date).format("YYYY-MM-DD HH:mm:ss") : "";
  };

  const headers = [
    "ID",
    t("common.sender"),
    t("common.receiver"),
    t("common.amount"),
    t("common.currency"),
    t("common.date"),
    t("common.status"),
    t("common.tag"),
  ];

  const csvRows = transactionList.value.map((tr) =>
    [
      escapeCsvField(tr.id),
      escapeCsvField(tr.senderName),
      escapeCsvField(tr.receiverName),
      escapeCsvField(tr.amount),
      escapeCsvField(tr.currency),
      escapeCsvField(formatDate(tr.creation_date)),
      escapeCsvField(tr.status),
      escapeCsvField(tr.tag),
    ].join(","),
  );

  const csvContent = [headers.join(","), ...csvRows].join("\n");
  const safeStartDate = (startDate.value || "").replace(/[\/:]/g, "-");
  const safeEndDate = (endDate.value || "").replace(/[\/:]/g, "-");
  const fileName = `transactions_${safeStartDate}_${safeEndDate}.csv`;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  try {
    if (Capacitor?.isNativePlatform?.()) {
      const csvFile = await write_blob({
        path: fileName,
        directory: Directory.Documents,
        blob,
        recursive: true,
        fast_mode: true,
      });
      await FileOpener.openFile({
        filePath: csvFile.uri,
        contentType: "text/csv",
      });
    } else {
      downloadWeb(blob, fileName);
    }
  } catch (e) {
    f7.toast.show({
      text: t("transaction.downloadFailed"),
      position: "center",
    });
  }
}

function downloadWeb(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  link.classList.add("external");
  link.target = "_blank";
  link.rel = "noopener";
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
}

const endDate = computed(() => {
  return extractionPeriod.value.length > 0 ? extractionPeriod.value[1] : "";
});

const startDate = computed(() => {
  return extractionPeriod.value.length > 0 ? extractionPeriod.value[0] : "";
});

const campaignDays = computed(() => {
  return startDate.value && endDate.value
    ? f7.$dayjs(endDate.value).diff(f7.$dayjs(startDate.value), "day")
    : 0;
});
</script>
